import * as React from 'react'

import {
  useSchedulingWizard,
  setResultsPageActionCreator as setPage,
} from '../wizardContext'
import { Pagination } from './atoms'
import PaginationItem from '@mui/material/PaginationItem/PaginationItem'
import SkipNextIcon from '@mui/icons-material/SkipNext'
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious'
type ResultsPaginationProps = {
  perPage?: number
}

export function ResultsPagination(props: ResultsPaginationProps) {
  const { perPage = 3 } = props

  const [state, dispatch] = useSchedulingWizard()

  const { loading, page, commitProcessing, response } = state

  const disabled = loading || commitProcessing

  const pages = Math.ceil((response?.count ?? 0) / perPage)

  const onChange = React.useCallback(
    (_, newPage: number) => dispatch(setPage(newPage - 1)),
    [dispatch],
  )

  return pages <= 1 ? null : (
    <Pagination
      count={pages}
      color="primary"
      page={page + 1}
      onChange={onChange}
      disabled={disabled}
      data-test-id="results-pagination"
      showFirstButton
      showLastButton
      renderItem={(item) => (
        <PaginationItem
          {...item}
          slots={{
            first: SkipPreviousIcon,
            last: SkipNextIcon,
          }}
        />
      )}
    />
  )
}
